import { nonNullable } from '@wix/wix-data-client-common-standalone'
import type {
  EditorSDK,
  Logger,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import { cloneDeep, entries } from 'lodash'

export const removeStaleRoutes = async ({
  editorSdkProxy,
  logger,
}: {
  editorSdkProxy: EditorSDK
  logger: Logger
}) => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()
  routers.forEach(async router => {
    const connectedPagesRoles = router.pages
      .map(pageDescriptor => pageDescriptor.pageRoles)
      .flat()

    const stalePatterns = entries(router.config.patterns)
      .map(([pattern, routeConfig]) =>
        !connectedPagesRoles.includes(routeConfig.pageRole) ? pattern : null,
      )
      .filter(nonNullable)

    if (stalePatterns.length > 0) {
      const cleanedUpRouterConfig = cloneDeep(router.config)
      stalePatterns.forEach(stalePattern => {
        delete cleanedUpRouterConfig.patterns[stalePattern]
      })
      const routerRef = await editorSdkProxy.routers.getByPrefix({
        prefix: router.prefix,
      })
      editorSdkProxy.routers
        .update({
          routerRef: routerRef,
          config: cleanedUpRouterConfig,
        })
        .catch(error =>
          logger.error(
            new Error(
              `Failed to delete stale routes from ${router.id} router.`,
              { cause: error },
            ),
          ),
        )
    }
  })
}
